import { NgModule } from '@angular/core';
import { FunctionLockService, PayrollService } from "@services";
// Deep import, not the "@slick-components" barrel. An NgModule's imports/providers are emitted into
// a static field initializer, which runs at class-definition time - and the barrel is circular with
// this file (@slick-components -> slick-emailer.component -> ../../services -> @stores -> here), so
// through the barrel this binding is in its TDZ on re-entry and the bundle dies at load with
// "Cannot access 'Zt' before initialization".
import { SlickToastModule } from '../slick-components/slick-toast/slick-toast.module';

import { AccountingStore } from "./accounting.store";
import { ChatStore } from "./chat.store";
import { CreditCardStore } from "./credit-card.store";
import { InventoryStore } from "./inventory.store";
import { LathamOrdersPickListStore } from "./latham-orders-pick-list.store";
import { LoggerStore } from "./logger.store";
import { PhotoUploadStore } from "./photo-upload.store";
import { SignalRMessageStore } from "./signalr-message.store";
import { TabsStore } from "./tabs.store";
import { TextChatStore } from "./text-chat.store";
import { ThemeStore } from "./theme.store";
import { TimeclockStore } from "./timeclock.store";

@NgModule({
	// SlickToastModule belongs here, not in providers: PhotoUploadStore injects SlickToastService,
	// and that service is a plain @Injectable() supplied by this module. Listed under providers it
	// was only ever a token, so it never actually provided the service.
	imports: [SlickToastModule],
	providers: [AccountingStore,
		ChatStore,
		CreditCardStore,
		InventoryStore,
		LathamOrdersPickListStore,
		LoggerStore,
		PhotoUploadStore,
		SignalRMessageStore,
		TabsStore,
		TextChatStore,
		ThemeStore,
		TimeclockStore]
})
export class StoresModule { }

